import {Component, HostListener, Input, ChangeDetectionStrategy} from '@angular/core';
import {OffsetModifier} from '@popperjs/core/lib/modifiers/offset';
import {DropdownMenuComponent} from '../../dropdown-menu';
import {MainMenuItem} from '../main-menu-item';

const ROUTER_LINK_ACTIVE_CLASS = '-active';

@Component({
    selector: 'ul[dropdown-main-menu]',
    templateUrl: './main-menu-dropdown.component.html',
    styleUrls: ['./main-menu-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MainMenuDropdownComponent extends DropdownMenuComponent {

    @Input()
    public override menuItems: MainMenuItem[];

    @Input()
    public logout?: () => void; // [HED-934] Is empty for Guest user.

    public routerLinkActiveClass = ROUTER_LINK_ACTIVE_CLASS;

    /**
     * See {@link RouterLinkActive.routerLinkActiveOptions}
     */
    public readonly defaultRouterLinkActiveOptions = {exact: false};

    @HostListener('click')
    public onHostClick(): void {
        this.close();
    }

    @HostListener('document:keydown')
    public override onKeyDown(): void {
        // Override parent.
    }

    public logoutClick(): void {
        this.logout!();
    }

    protected override initPopper(): void {
        super.initPopper({
            placement: 'bottom-start'
        });
    }

    protected override getPopperOffsetModifier(): OffsetModifier {
        return {
            ...super.getPopperOffsetModifier(),
            options: {
                offset: [-8, 24]
            }
        };
    }

    protected override listenToItemsHover(): void {
        // Override parent.
    }

}
